import { Colors, Utils, Storage } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column } from '@lightningjs/ui-components';

export default class AudioSubtitlesSeries extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      plinko: true,
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      AudioSubtitlesLogo: {
        x: 445,
        y: 340,
        texture: Lightning.Tools.getSvgTexture(
          Utils.asset('/images/settings-icons/audio-subtitles.svg'),
          116,
          126
        ),
      },
      AudioSubtitlesTitle: {
        x: 290,
        y: 510,
        w: 394,
        text: {
          text: 'Audio & Subtitles',
          textColor: Colors('#fafafa').get(),
          textAlign: 'center',
          fontSize: 50,
        },
      },
      Audio: {
        x: 1050,
        y: 150,
        text: {
          text: 'Audio',
          fontSize: 36,
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#fafafa').get(),
        },
        fontSize: 35,
        Column: {
          collision: true,
          y: 70,
          type: Column,
        },
      },
      Subtitles: {
        x: 1050,
        y: 460,
        text: {
          text: 'Subtitles',
          fontSize: 36,
          fontFace: 'OpenSans-SemiBold',
          textColor: Colors('#fafafa').get(),
        },
        fontSize: 35,
        Column: {
          collision: true,
          y: 70,
          type: Column,
        },
      },
    };
  }

  get _Subtitles() {
    return this.tag('Subtitles.Column');
  }

  get _Audio() {
    return this.tag('Audio.Column');
  }

  set serieId(val) {
    this._serieId = val;
  }

  _active() {
    this._setState('Audio');
  }

  _init() {
    this._currentlyFocused = this._Audio;
  }

  _enable() {
    let contentPreferences = Storage.get('content_preferences');
    let profileId = Storage.get('profileId');
    let profileInfo = Storage.get('profileInfo');
    let audioSubtitles = Storage.get(`audiosubtitles-${profileId}`);
    let movieConfiguration = contentPreferences?.find(
      (preference) =>
        preference.profileId === profileId && Number(preference.serieId) === this._serieId
    );
    const audioOptions = this._Audio.items.map((item) => item.audio);
    const subtitleOptions = this._Subtitles.items.map((item) => item.subtitle);
    let subtitleIndex = subtitleOptions.findIndex(
      (option) => option.lng === movieConfiguration?.subtitle
    );
    let foundIndex = audioOptions.findIndex((option) => option.lng === movieConfiguration?.audio);
    if (subtitleIndex === -1) {
      subtitleIndex = subtitleOptions.findIndex(
        (option) => option.lng === audioSubtitles?.subtitle
      );
      if (subtitleIndex === -1) {
        subtitleIndex = 0;
      }
    }
    if (foundIndex === -1) {
      foundIndex = audioOptions.findIndex((option) => option.lng === audioSubtitles?.audio);
      if (foundIndex === -1) {
        foundIndex = 0;
      }
    }
    this._Audio.items[foundIndex]._selectAudioButton();
    this._Audio.selectedIndex = foundIndex;
    this._Subtitles.items[subtitleIndex]._selectSubtitleButton();
    this._Subtitles.selectedIndex = subtitleIndex;
  }

  $setState(state) {
    this._setState(state);
  }

  $setIndex(index) {
    this._Audio.selectedIndex = index;
  }

  $setSubtitleIndex(index) {
    this._Subtitles.selectedIndex = index;
  }

  static _states() {
    return [
      class Audio extends this {
        _getFocused() {
          return this._Audio;
        }

        _handleDown() {
          this._setState('Subtitles');
        }
      },
      class Subtitles extends this {
        _getFocused() {
          return this._Subtitles;
        }

        _handleUp() {
          this._setState('Audio');
        }
      },
    ];
  }
}
